import { FC, useMemo, useCallback } from 'react';
import intl from 'react-intl-universal';
import { FormItem, Dropdown } from '@getsynapse/design-system';
import { Option } from 'utils/customTypes';
import { PROJECT_RESOURCING_TYPE } from 'utils/constants/projectsList';
import { ProjectResourcingType } from 'utils/types/projectsList';

interface ProjectResourcingTypeFilterProps {
  onSelect: (selected: ProjectResourcingType[]) => void;
  selected?: ProjectResourcingType[];
}

const ProjectResourcingTypeFilter: FC<ProjectResourcingTypeFilterProps> = ({
  selected,
  onSelect,
}) => {
  const resourcingTypeOptions = useMemo(() => {
    return Object.keys(PROJECT_RESOURCING_TYPE).map((key) => ({
      value:
        PROJECT_RESOURCING_TYPE[key as keyof typeof PROJECT_RESOURCING_TYPE],
      label: intl.get(`PROJECT_DETAIL.RESOURCING_TYPE_OPTIONS.${key}`),
    }));
  }, []);

  const selectedOptions = useMemo(() => {
    return resourcingTypeOptions.filter((option) =>
      selected?.includes(option.value as ProjectResourcingType)
    );
  }, [resourcingTypeOptions, selected]);

  const handleOnChange = useCallback(
    (selectedOptions: Option[]) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      onSelect(selectedValues as ProjectResourcingType[]);
    },
    [onSelect]
  );

  return (
    <FormItem label={intl.get('PROJECT_DETAIL.RESOURCING_TYPE')}>
      <Dropdown
        options={resourcingTypeOptions}
        values={selectedOptions}
        onChange={handleOnChange}
        multiple
        placeholder={intl.get('FILTER_GENERAL.PLACEHOLDER')}
        triggerProps={{
          'aria-label': 'project-resourcing-type-filter',
        }}
      />
    </FormItem>
  );
};

export default ProjectResourcingTypeFilter;
